import React from 'react'

import { APPLY_FORM_LINK } from './data'

const ApplyNow = () => {
  return (
    <div className="flex flex-col justify-center py-7 px-5">
      <h1 className="sr-only">Apply Now</h1>
      {/* <PricingSection /> */}

      <div className="flex flex-col  md:px-32">
        <div className="text-2xl font-medium">
          Why this 7 months course is at such a Dirt Cheap Price?
        </div>

        <div className="text-xl pt-4 pb-4">
          ▸ It’s Because Accessibility in Education is very important to us.
        </div>

        <div className="text-xl">
          ▸ We wish for a world where everyone in the world has access to
          Premium Education and we are taking a stand for it.
        </div>

        <div className="mt-8 pt-3 pb-8">
          <div className="bg-zinc-800 rounded-md inline-block py-3 px-4">
            <p className="text-2xl font-medium">
              Have any doubts?
              <a
                className="text-primary hover:text-primary-light"
                href={APPLY_FORM_LINK}
                target="_blank"
                rel="noopener noreferrer">
                {' '}
                Please click here to contact us →{' '}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

ApplyNow.seo = {
  title: 'Apply | Devsnest'
}

export default ApplyNow
